module.exports = __webpack_public_path__ + "static/media/fidel.8008d95a.png";